import http from './axios'
const url = ''
export function getDate(data) {
    return http({
        url: '/system/dict/data/type/map',
        method: 'get',
        params:data
    })
}
export function getNewsDate(data) {
  return http({
    url: '/website/resource',
    method: 'get',
    params: data
  })
}
export function getNewsDatebyId(data) {
  return http({
    url: '/website/resource/' + data,
    method: 'get',
  })
}
export function getWebsite(query) {
  return http({
    url: '/website/resource',
    method: 'get',
    params: query
  })
}

export function submitComment(query) {
  return http({
    url: '/website/comment',
    method: 'post',
    data: query
  })
}

export function friendLink(query) {
  return http({
    url: '/website/friend_link',
    method: 'get',
    params: query
  })
}

export function setAction(query) {
  return http({
    url: '/action',
    method: 'post',
    data: query
  })
}

// 领取大礼包
export function contactUs(query) {
  return http({
    url: '/contactUs/save',
    method: 'post',
    data: query
  })
}

export function getDictTypeMap(type) {
  return http({
    url: '/system/dict/data/type/map',
    method: 'get',
    params: {
      dictType: type
    }
  })
}


// WEBPACK FOOTER //
// ./src/api/request.js